import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import settingsSlice from './slices/settingsSlice';

const persistConfig = {
  key: 'hms-root',
  storage,
  whitelist: ['auth'], // Only persist auth state
  version: 1,
};

const rootReducer = persistCombineReducers(persistConfig, {
  auth: authSlice,
  ui: uiSlice,
  settings: settingsSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST', 
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER'
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 